import Immutable from 'seamless-immutable';

import {
    SUBMISSION_LIST_REQUEST,
    SUBMISSION_LIST_SUCCESS,
    SUBMISSION_LIST_ERROR,
    SUBMISSION_LIST_UPDATE_FILTER,
    SUBMISSION_LIST_UPDATE_SEARCH_FILTER,
    SUBMISSION_LIST_CLEAR,
} from 'Actions/submission';
import { PROCESS_STATUS_REJECTED } from 'Constants';
import { searchRelevanceToClass } from 'Utils';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    filter: {
        where: {
            status: 'active',
            process_status: {neq: PROCESS_STATUS_REJECTED }
        },
        page: 1,
        include: ['journal', 'status', 'profiles', 'results'],
        search: 0,
        order: 'default desc',
    },
    tmpFilter: { where: {} },
    data: [],
    metadata: {},
});

export default function packListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SUBMISSION_LIST_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case SUBMISSION_LIST_SUCCESS: {
            let payloadData = action.payload && action.payload.data;
            if (payloadData) {
                let maxRelevance = 0;
                payloadData.forEach(submission => {
                    if (submission.relevance && submission.relevance > maxRelevance) {
                        maxRelevance = submission.relevance;
                    }
                });

                payloadData.forEach((submission, key, list) => {
                    list[key] = {
                        ...submission,
                        realId: submission.id,
                        id: 'MA' + submission.id,
                        authors: submission.profiles ? submission.profiles.map(profile => profile.name).join(', ') : '',
                        result: submission.results ? submission.results.find(result => result.status_id === submission.status_id) : null,
                        rawClassName: (submission.relevance ? searchRelevanceToClass(submission.relevance, maxRelevance) : '') +
                            (submission.is_overdue ? ' raw-overdue' : submission.is_new ? ' raw-new' : '')
                    };
                });
            }

            return state.merge({
                loading: false,
                success: true,
                error: false,
                data: action.payload.metadata && action.payload.metadata.page ? payloadData : state.data,
                metadata: action.payload.metadata && action.payload.metadata.page ? action.payload.metadata : state.metadata,
            });
        }

        case SUBMISSION_LIST_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        case SUBMISSION_LIST_UPDATE_FILTER:
            return state.merge({
                filter: state.filter.merge(action.payload),
            });

        case SUBMISSION_LIST_UPDATE_SEARCH_FILTER:
            return state.merge({
                tmpFilter: state.tmpFilter.merge(action.payload),
            });

        case SUBMISSION_LIST_CLEAR:
            return INITIAL_STATE;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/submissionsListReducer.js